import colors from 'styles/colors'

const styles = {
  iconTextContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  icon: {
    fontSize: 25,
    color: colors.primary,
    marginBottom: 19
  },
  title: {
    fontFamily: 'Barlow',
    fontSize: 16,
    fontWeight: 700,
    letterSpacing: '0.23px',
    lineHeight: '24px',
    marginBottom: 5,
    color: colors.lightGray
  },
  text: {
    color: colors.lightGray,
    fontFamily: 'Barlow',
    fontSize: 12,
    lineHeight: '17px'
  }
}

export default styles
